/**
 * Created by claudio iozzia on 14/06/2017.
 */
export class siPrefix {  // http://en.wikipedia.org/wiki/SI_prefix

  public  get value(): number {
    return this._value;
  }

  public get symbol(): string {
    return this._symbol;
  }

  private constructor(private _value: number, private _symbol: string) { }

  public static get yotta() : siPrefix { return  new siPrefix( 1E24  , "Y"); }// 1 000 000 000 000 000 000 000 0000
  public static get zetta() : siPrefix { return  new siPrefix( 1E21  , "Z"); }// 1 000 000 000 000 000 000 000
  public static get exa()   : siPrefix { return  new siPrefix( 1E18  , "E"); }// 1 000 000 000 000 000 000
  public static get peta()  : siPrefix { return  new siPrefix( 1E15  , "P"); }// 1 000 000 000 000 000
  public static get tera()  : siPrefix { return  new siPrefix( 1E12  , "T"); }// 1 000 000 000 000
  public static get giga()  : siPrefix { return  new siPrefix( 1E9   , "G"); }// 1 000 000 000
  public static get mega()  : siPrefix { return  new siPrefix( 1E6   , "M"); }// 1 000 000
  public static get kilo()  : siPrefix { return  new siPrefix( 1E3   , "k"); }// 1 000
  public static get unit()  : siPrefix { return  new siPrefix( 1E0   , "" ); }// 1
  public static get milli() : siPrefix { return  new siPrefix( 1E-3  , "m"); }// 0.001
  public static get micro() : siPrefix { return  new siPrefix( 1E-6  , "µ"); }// 0.000 001
  public static get nano()  : siPrefix { return  new siPrefix( 1E-9  , "n"); }// 0.000 000 001
  public static get pico()  : siPrefix { return  new siPrefix( 1E-12 , "p"); }// 0.000 000 000 001
  public static get femto() : siPrefix { return  new siPrefix( 1E-15 , "f"); }// 0.000 000 000 000 001
  public static get atto()  : siPrefix { return  new siPrefix( 1E-18 , "a"); }// 0.000 000 000 000 000 001
  public static get zepto() : siPrefix { return  new siPrefix( 1E-21 , "z"); }// 0.000 000 000 000 000 000 001
  public static get yocto() : siPrefix { return  new siPrefix( 1E-24 , "y"); }// 0.000 000 000 000 000 000 000 001

  public static get prefixes(): Array<siPrefix> {
    return [siPrefix.femto
            , siPrefix.pico
            , siPrefix.nano
            , siPrefix.micro
            , siPrefix.milli
            , siPrefix.unit
            , siPrefix.kilo
            , siPrefix.mega
            , siPrefix.giga
            , siPrefix.tera
            , siPrefix.peta
          ];
  }

  public static get percentage(): siPrefix { return  new siPrefix( 1E-2  , "%"); }// 0.01 %

}
